<template>
  <div class="row">
    <div class="card-body p-0">
      <div class="row">
        <div class="form-group col-md-12">
          <button
            type="button"
            class="btn btn-primary"
            @click="addPath()"
            v-if="paths.length == 0"
          >
            Agregar Puntos
          </button>
          <button type="button" class="btn btn-danger" @click="removePath()">
            Eliminar Puntos
          </button>
        </div>
        <div class="col-md-8">
          <gmap-map
            :center="center"
            :zoom="17"
            style="width: 100%; height: 400px"
            ref="map"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :icon="m.icon"
            ></gmap-marker>
            <gmap-polygon
              v-if="paths.length > 0"
              :paths="paths"
              :editable="true"
              @paths_changed="editarPoligono($event)"
              @rightclick="handleClickForDelete"
              ref="polygon"
            >
            </gmap-polygon>
          </gmap-map>
        </div>
        <div class="col-md-4">
          <table class="table table-bordered table-striped table-hover table-sm">
            <thead>
              <tr>
                <th class="col-4">Posicion</th>
                <th class="col-4">Longitud</th>
                <th class="col-4">Latitud</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="puntos in paths[0]"
                :key="puntos.id"
                class="text-center"
              >
                <td v-text="puntos.posicion"></td>
                <td v-text="puntos.lng"></td>
                <td v-text="puntos.lat"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BloqueMapPoli",
  data() {
    return {
      form: {},
      latitud: null,
      longitud: null,
      center: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      places: [],
      edited: null,
      paths: [],
      mvcPaths: null,
      errorMessage: null,
      polygonGeojson: "",
    };
  },

  watch: {
    polygonPaths: function (paths) {
      if (paths) {
        this.paths = paths;
      }
    },
  },

  computed: {
    polygonPaths: function () {
      if (!this.mvcPaths) return null;

      let paths = [];
      for (let i = 0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({
            id: j,
            lat: point.lat(),
            lng: point.lng(),
            posicion: j + 1,
          });
        }
        paths.push(path);
      }
      return paths;
    },
  },

  methods: {
    closeLoop(path) {
      return path.concat(path.slice(0, 1));
    },

    markerBloque() {
      this.latitud = this.$parent.formGeocerca.latitud;
      this.longitud = this.$parent.formGeocerca.longitud;
      const marker = {
        lat: parseFloat(this.latitud),
        lng: parseFloat(this.longitud),
      };
      this.center = marker;
    },

    addPath: function () {
      var bounds = this.$refs.map.$mapObject.getBounds();
      var northEast = bounds.getNorthEast();
      var southWest = bounds.getSouthWest();
      var center = bounds.getCenter();
      var degree = this.paths.length + 1;
      var f = Math.pow(0.66, degree);

      var path = [
        {
          lng: center.lng(),
          lat: (1 - f) * center.lat() + f * northEast.lat(),
          posicion: 1,
        },
        {
          lng: (1 - f) * center.lng() + f * southWest.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
          posicion: 2,
        },
        {
          lng: (1 - f) * center.lng() + f * northEast.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
          posicion: 3,
        },
      ];

      this.paths.push(path);
    },

    removePath: function () {
      this.paths.splice(this.paths.length - 1, 1);
    },

    editarPoligono: function (mvcPaths) {
      this.mvcPaths = mvcPaths;
    },

    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex);
      }
    },

    readGeojson: function ($event) {
      try {
        this.polygonGeojson = $event.target.value;

        var v = JSON.parse($event.target.value);

        this.paths = v.coordinates.map((linearRing) =>
          linearRing
            .slice(0, linearRing.length - 1)
            .map(([lng, lat]) => ({ lat, lng }))
        );

        this.errorMessage = null;
      } catch (err) {
        this.errorMessage = err.message;
      }
    },

    initPaths() {
      let puntos = this.$parent.$parent.form?.geocerca?.puntos ?? null;

      if (puntos) {
        let paths = new Array();
        for (let i = 0; i < puntos.length; i++) {
          let punto = {
            lng: parseFloat(puntos[i]["longitud"]),
            lat: parseFloat(puntos[i]["latitud"]),
            posicion: parseFloat(puntos[i]["posicion"]),
          };
          paths.push(punto);
        }
        this.paths.push(paths);

        this.center = {
          lng: parseFloat(puntos[0]["longitud"]),
          lat: parseFloat(puntos[0]["latitud"]),
        };
      } else if (this.$parent.$parent.form.geocerca) {
        this.center = {
          lng: parseFloat(this.$parent.$parent.form.geocerca.longitud),
          lat: parseFloat(this.$parent.$parent.form.geocerca.latitud),
        };
      }
    },
  },

  mounted() {
    this.markerBloque();
    this.initPaths();
  },
};
</script>
